// extracted by mini-css-extract-plugin
module.exports = {"krTabs":"KRTabs_krTabs__wihRZ"};